import { TripTableSort } from '../../../enums';

export interface ITripsTableFilters {
    scheduledDate?: [string, string];
    visitDate?: [string, string];
    /** Ya lo acepta el BFF (`TripsFilters.realFinish`); el tablero de incidencias lo usa para los viajes cerrados. */
    realFinish?: [string, string];
    licensePlate?: string[];
    driverName?: string[];
    carrierName?: string[];
    vehicleIds?: string[];
    driverIds?: string[];
    carrierIds?: string[];
    origin?: string[];
    destination?: string[];
    tripCode?: string;
}

export interface ITripsTableArgs {
    page: number;
    from?: string | null;
    to?: string | null;
    limit?: number | null;
    filters?: ITripsTableFilters;
    tripDefinitionIds?: string[];
    sort?: TripTableSort[];
}
